import { Box, UtilityText } from "@leagueplatform/genesis-core";
import {
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
} from "@leagueplatform/masonry-engine";

type MasonryBrandingBannerProperties = {
  eyebrow?: string;
};

type MasonryBrandingBannerNode = MasonryEngineNode<
  "heroBanner",
  MasonryBrandingBannerProperties
>;

type MasonryBrandingBannerRendererProps =
  MasonryEngineNodeRendererProps<MasonryBrandingBannerNode>;

export const MasonryBrandingBannerRenderer = ({
  eyebrow,
}: MasonryBrandingBannerRendererProps) => {
  if (!eyebrow) return null;
  return (
    <Box
      css={{
        position: "relative",
        isolation: "isolate",
        paddingBlock: "$half",
        marginBlockEnd: "$twoAndHalf",
        "@mobile": {
          paddingBlock: 0,
          display: "flex",
          alignItems: "center",
          minHeight: "35px",
          marginBlockEnd: "$oneAndHalf",
        },
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          insetInlineStart: "calc(50% - 50vw)",
          width: "100vw",
          background: "$surfaceBackgroundSecondary",
          zIndex: -1,
        },
      }}
    >
      <UtilityText
        css={{
          typography: "$overline",
          color: "$onSurfaceTextSubdued",
          textTransform: "uppercase",
        }}
      >
        {eyebrow}
      </UtilityText>
    </Box>
  );
};
